import { List } from 'antd'
import styled from 'styled-components'

import { SWMSHRCWDisplayBlock } from '../../types/blueprint'

import { useLocale } from '@/context/localeContext'
import { hrcw } from '@/modules/swms-builder/data/hrcw'

const Title = styled.span`
  text-transform: capitalize;
`

type Props = {
  block: SWMSHRCWDisplayBlock
}

export const SwmsHrcwDisplayBlock: React.FC<Props> = ({ block }) => {
  const { t } = useLocale()
  if (!block.value?.length) return <>N/A</>

  const matchedHrcw = block.value
    ? hrcw(t).filter((h) => block.value.includes(h.id))
    : []

  return (
    <List
      itemLayout="horizontal"
      dataSource={matchedHrcw}
      renderItem={(item) => (
        <List.Item>
          <List.Item.Meta
            title={<Title>{item.id}</Title>}
            description={item.description}
          />
        </List.Item>
      )}
    />
  )
}
